import styled from "styled-components"
import CloudinaryImage from "components/cloudinary-image"
import { maxWidth, when } from "utils"

export const Container = styled.div`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};
`

export const Image = styled(CloudinaryImage)`
  height: 100%;
  width: 100%;

  position: absolute;
  top: 0;
  left: 0;

  img {
    ${(props) =>
      props.aspectRatios.desktop > 1.0001 &&
      `
      object-fit: contain;
    `};
  }

  ${when("useOriginalAspectRatio")`
    position: relative;
    height: 0;
    padding-bottom: ${(props) => props.aspectRatios.desktop * 100}%;
  `}

  ${maxWidth.desktop`
    position: relative;
    height: 0;
    padding-bottom: ${(props) => props.aspectRatios.desktop * 100}%;

    ${(props) =>
      props.aspectRatios.desktop > 1.0001 &&
      `
      padding-bottom: 0;
      height: 35rem;
    `}
  `}

  ${maxWidth.tablet`
    padding-bottom: ${(props) => props.aspectRatios.tablet * 100}%;

    ${(props) =>
      props.aspectRatios.tablet > 1.0001 &&
      `
      padding-bottom: 0;
      height: 35rem;
    `}
  `}

  ${maxWidth.mobile`
    padding-bottom: ${(props) => props.aspectRatios.mobile * 100}%;

    ${(props) =>
      props.aspectRatios.mobile > 1.0001 &&
      `
      padding-bottom: 0;
      height: 35rem;
    `}
  `}
`
